import { render, staticRenderFns } from "./RequestStatus.vue?vue&type=template&id=81579dd8&scoped=true&"
import script from "./RequestStatus.vue?vue&type=script&lang=js&"
export * from "./RequestStatus.vue?vue&type=script&lang=js&"
import style0 from "./RequestStatus.vue?vue&type=style&index=0&id=81579dd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81579dd8",
  null
  
)

export default component.exports